// This file is automatically generated by /scripts/git-version.ts
export const versions = {
  version: '0.0.0',
  revision: '873092a73943c18970c5c2426819c15fb97d9ac9',
  branch: 'master',
};
